import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Button from "@material-ui/core/Button";
import Grow from '@material-ui/core/Grow';
import modalStyle from './style'
import {getTranslation} from "../../helpers/get-translation";

const styles = theme => (Object.assign({}, modalStyle, {
	modalBody: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5]
	},
	button:{
		display: 'block',
		margin: 'auto',
		marginTop: '20px'
	}
}));


const BaseModal = props => {
	const { modal, classes, removeModalWindow } = props;
	return (
		<Modal
			className={classes.modal}
			open={true}
		>
			<Grow in={true}>
				<div className={`${classes.modalBody} ${classes.defaultBody}`}>
					{modal.hasHtml && <div dangerouslySetInnerHTML={{__html: modal.message}}/>}
					{!modal.hasHtml && <div>{modal.message}</div>}

					<Button
						variant="contained"
						className={`${classes.button}`}
						onClick={() => {removeModalWindow()}}
					>
						Ok
					</Button>
				</div>
			</Grow>
		</Modal>
	)
}

BaseModal.propTypes = {
	modal: PropTypes.object.isRequired,

	classes: PropTypes.shape({
		modal: PropTypes.string.isRequired,
		modalBody: PropTypes.string.isRequired,
		button: PropTypes.string.isRequired,
	}).isRequired,

	removeModalWindow: PropTypes.func.isRequired,
}


export default withStyles(styles)(BaseModal);
